<template lang="pug">
  .b-auth-input(:class="{ fullwidthOn768: !!fullwidthOn768, type }")
    input._field(
      :type="computedType"
      :placeholder="label"
      :class="{ error: !!error }"
      :value="value"
      v-on="inputListeners"
      )
    ._eye(v-if="type === 'password'" @click="showPassword = !showPassword")
      Icon(:name="showPassword ? 'eye-closed' : 'eye-opened'" pointer)
    ._error-text(v-if="error") {{ error }}
</template>

<script>
export default {
  name: 'CommonInput',
  props: {
    value: String,
    type: String,
    label: String,
    error: String,
    fullwidthOn768: Boolean,
  },
  data() {
    return {
      showPassword: false,
    };
  },
  computed: {
    computedType() {
      return this.showPassword ? 'text' : this.type;
    },
    inputListeners() {
      return {
        ...this.$listeners,
        input: (event) => this.$emit('input', event.target.value),
      };
    },
  },
};
</script>

<style scoped lang="scss">
.auth-input {
  width: 100%;
  position: relative;

  &__field {
    display: block;
    min-width: 286px;
    border: 1px solid transparent;
    padding: 12px 13px 16px;
    background: rgba(235, 239, 242, 0.5);
    border-radius: 6px;
    color: var(--color-dark-gray);
    font-weight: 500;
    font-size: 12px;
    outline: none;

    &::placeholder {
      opacity: 1;
      font-size: 12px;
      color: var(--color-dark-gray);
      font-weight: 500;
    }

    &.error {
      border: 1px solid!important;
      color: var(--color-red)!important;
      margin-bottom: 4px!important;
    }
  }

  &__eye {
    position: absolute;
    right: 15px;
    top: 12px;
  }

  &__error-text {
    max-width: 286px;
    text-align: left;
    color: var(--color-red)!important;
    letter-spacing: .01em;
    font-weight: 500;
    line-height: 13px;
    font-size: 10px;
    padding: 0 16px;
  }

  @media (max-width: 500px) {
    &__field {
      min-width: calc(100% - 26px);
    }

    &__error-text {
      min-width: calc(100% - 26px);
    }
  }

  @media (max-width: 768px) {
    &.fullwidthOn768 &__field {
      min-width: calc(100% - 26px);
    }

    &.fullwidthOn768 &__error-text {
      min-width: calc(100% - 26px);
    }
  }
}
</style>
